<template>
  <section>
    <PageTitle title="Galeria zdjęć" />
    <div
      class="container px-4 pt-32 mx-auto text-center sm:px-0 lg:px-0 xl:px-0 2xl:px-64 md:pt-40 lg:pt-40 2xl:pt-56 sm:text-left"
    >
      <main>
        <section class="px-4 py-8">
          <div class="flex flex-wrap -mx-4">
            <div v-for="(image, i) in images" :key="i" class="px-4 mb-8 md:w-1/4">
              <img :src="image" :key="i" @click="index = i" class="rounded shadow-md" alt />
            </div>
            <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
          </div>
        </section>
      </main>
    </div>
  </section>
</template>

<script>
import PageTitle from "../components/PageTitle";
import VueGallerySlideshow from "vue-gallery-slideshow";

export default {
  name: "Gallery",
  components: {
    PageTitle,
    VueGallerySlideshow,
  },
  data() {
    return {
      images: [
        require("../assets/galeria/haft-poznan-01.jpg"),
        require("../assets/galeria/haft-poznan-02.jpg"),
        require("../assets/galeria/haft-poznan-03.jpg"),
        require("../assets/galeria/haft-poznan-04.jpg"),
        require("../assets/galeria/haft-poznan-05.jpg"),
        require("../assets/galeria/haft-poznan-06.jpg"),
        require("../assets/galeria/haft-poznan-07.jpg"),
        require("../assets/galeria/haft-poznan-08.jpg"),
        require("../assets/galeria/haft-poznan-09.jpg"),
        require("../assets/galeria/haft-poznan-10.jpg"),
        require("../assets/galeria/haft-poznan-11.jpg"),
        require("../assets/galeria/haft-poznan-12.jpg"),
        require("../assets/galeria/haft-poznan-13.jpg"),
        require("../assets/galeria/haft-poznan-14.jpg"),
        require("../assets/galeria/haft-poznan-15.jpg"),
        require("../assets/galeria/16.jpg"),
        require("../assets/galeria/17.jpg"),
        require("../assets/galeria/18.jpg"),
        require("../assets/galeria/19.jpg"),
        require("../assets/galeria/20.jpg"),
        require("../assets/galeria/21.jpg"),
        require("../assets/galeria/22.jpg"),
        require("../assets/galeria/23.jpg"),
        require("../assets/galeria/24.jpg"),
        require("../assets/galeria/25.jpg"),
        require("../assets/galeria/26.jpg"),
      ],
      index: null,
      media: [
        {
          thumb: "../../assets/img/gallery/haft-poznan-01.jpg",
          src: "../../assets/img/gallery/haft-poznan-01.jpg",
          caption: "caption to display. receive <html> <b>tag</b>",
          srcset: "...",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
